import React from 'react'
import { isEmpty } from 'lodash'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Media from '~/components/media'
import Rating from '~/components/rating'
import theme from '~/truck/theme'

import RatingGraph from '../rating-graph'

const Container = styled.div`
  border-bottom: 1px solid ${theme.colors.gray};
  width: 100%;

  > :last-child {
    margin: ${theme.spacing.cozy * 3}px 0;
  }

  ${up('lg')} {
    align-items: center;
    align-self: center;
    display: flex;
    justify-content: center;
    padding-bottom: ${theme.spacing.cozy * 4}px;
  }
`

const Box = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: ${theme.spacing.cozy * 2}px;
  margin-top: -${theme.spacing.cozy}px;

  > :not(:last-child) {
    margin-bottom: ${theme.spacing.cozy}px;
  }

  ${up('lg')} {
    margin-bottom: 0;
    margin-right: ${theme.spacing.cozy * 4}px;
    margin-top: 0;
    width: ${theme.spacing.cozy * 14}px;
  }
`

const Content = styled.div`
  background-color: ${theme.colors.grayLight};
  border-radius: ${theme.dimensions.borderRadius}px;
  padding: ${theme.spacing.compact}px ${theme.spacing.comfortable}px;

  > :first-child {
    margin-right: ${theme.spacing.cozy}px;
  }
`

const Overview = props => {
  const { color, reviewStats, mobileData } = props

  const { numOfReviews, rating } = reviewStats

  const { productReviews, onClick, buttonAction } = mobileData

  return (
    <Container>
      <Box>
        <Content>
          <span className="text-4xl font-semibold">{rating.toFixed(1)}</span>
          <span className="text-xl">/5</span>
        </Content>
        <Rating initialRating={rating} />
        <span className="w-max font-semibold">
          {numOfReviews} reseña{numOfReviews > 1 && 's'}
        </span>
      </Box>
      <RatingGraph color={color} {...reviewStats} />
      {!isEmpty(productReviews) && (
        <Media
          mobile={
            <div className="text-center font-semibold text-brand-secondary" onClick={onClick}>
              {buttonAction}
            </div>
          }
        />
      )}
    </Container>
  )
}

export default Overview
